import SuperRepository from '../superRepository'

export default new (class UserFilterPresetRepository extends SuperRepository {
  baseUri() {
    return 'user_filter_preset'
  }
})()